export default __webpack_public_path__ + "static/2023_Quickbase_Empower_Quandary-87ef6cdfa4969d041c9e46c33e170511.png";